/* eslint-disable no-unneeded-ternary */
import React, { useState } from 'react'
import { Box } from '@mui/material'
import { PropTypes } from 'prop-types'
import config from '../../config/config'
import { SubSectionTitle } from './ProjectInputs'
const infoIcon = new URL('../../../../images/icons/info.svg', import.meta.url)

export default function ProjectInfo({ noWrap = false, infoText }) {
  const [text] = useState(
    infoText
      ? infoText
      : 'By default, the land use context shown on the map is selected. You can change it to suit your project needs.'
  )
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '5px'
      }}
    >
      <img src={infoIcon} style={{ width: '25x', height: '25px' }} />
      <SubSectionTitle
        color={config.themeConfig.semcogBlue1}
        noWrap={noWrap}
        fontWeight={400}
        fontSize={14}
      >
        {text}
      </SubSectionTitle>
    </Box>
  )
}
ProjectInfo.propTypes = {
  noWrap: PropTypes.bool,
  infoText: PropTypes.string
}
